<template>
  <div
    ref="headerHead"
    :class="[
      $style.header_head,
      $style[config.css || ''],
      'header_head_common',
    ]"
  >
    <div
      :class="[$style.name_area,$style.shared]"
    >
      <div
        v-if="config.ui.includes('publicUrlInfo')"
        :class="$style.public_url_title"
      >
        <div
          v-if="config.ui.includes('logo')"
          :class="[$style.logo_area, $style.tall_border]"
        >
          <vgp-svg-image
            name="logo"
          />
        </div>
        <div
          v-if="getPublicUrlInfo.logo"
          :class="[
            getPublicUrlInfo.css === 'image' ? $style.logo : $style.favicon,
          ]"
        >
          <img
            :src="getPublicUrlInfo.logo"
            alt=""
          >
        </div>
        <div
          v-if="getPublicUrlInfo.css !== 'image'"
          :class="[$style.text, $style.tall_border]"
        >
          <div :class="$style.user_shared_team">
            {{ getPublicUrlInfo.teamName }}
          </div>
        </div>
        <div
          :class="[$style.text, $style.title, 'project_name']"
        >
          {{ getPublicUrlInfo.projectName }}
        </div>

        <div
          :class="[$style.text_small, $style.user_shared_title]"
        >
          {{ getPublicUrlInfo.sharedBy }}
        </div>
      </div>

      <div
        ref="toolsArea"
        :class="$style.tools_area"
      >
        <div
          v-if="config.ui.includes('signUpButton')"
          :class="$style.sign_up"
        >
          <a
            href="#/signup"
            :class="$style.sign_up_btn"
            :data-logged-text="locales('logged_action_button_test')"
          >
            {{ locales("sign_up") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vgpSvgImage from '$$vueCmp/VueIcon/vgpSvgImage.vue';

export default {
  components: {
    vgpSvgImage,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    buttonColors: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      locales: __,
      inputMaxWidth: '',
      userTitleWidth: 0,
    };
  },
  computed: {
    getPublicUrlInfo() {
      return this.$store.getters['headerView/publicUrlInfo'];
    },
  },
};

</script>

<style module src="../../header/less/headView.less" lang="less"></style>
